export const DATABASE_OPTIMIZATION_FEATURE_KEY = 'database_optimization';

/**
 * Canonical color palette for DB instance series.
 * Expressed as MUI theme palette token strings — resolve with useTheme().
 * Matches the same palette used in UsageOverTimeChart (13 colors, index by
 * entityId hash so color assignment is deterministic).
 */
export const CHART_COLORS: string[] = [
  'indigo.700',
  'blue.700',
  'green.700',
  'yellow.700',
  'red.700',
  'blue.300',
  'indigo.300',
  'green.500',
  'indigo.200',
  'grey.500',
  'orange.700',
  'purple.700',
  'teal.700',
];
